export * from "./optimal-trip.component";
